import { formatNumber } from './format_number';
export function formatPercentage(value, options = {}) { return formatNumber(value, { ...options, style: 'percent' }); }
